package dev.lingvo.shared.screenshots.render

import dev.lingvo.shared.screenshots.text.CaptionFitter
import dev.lingvo.shared.screenshots.text.FitRequest
import dev.lingvo.shared.screenshots.text.FitResult
import dev.lingvo.shared.screenshots.text.Segmenter
import dev.lingvo.shared.screenshots.text.cssFont

/** Bounded LRU layouts omit position but retain every fitting input, including typography and measurement context. */
class FitCache(private val capacity: Int = 512) {
    private data class Key(val request: FitRequest, val css: String)
    private val entries = linkedMapOf<Key, FitResult>()
    private var measurer: TextMeasurer? = null
    private var segmenter: Segmenter? = null
    private var fitter: CaptionFitter? = null

    init { require(capacity > 0) { "Fit cache capacity must be positive" } }

    internal fun fit(req: FitRequest, fitter: CaptionFitter, measurer: TextMeasurer, segmenter: Segmenter): FitResult {
        if (this.measurer !== measurer || this.segmenter !== segmenter || this.fitter !== fitter) {
            entries.clear()
            this.measurer = measurer
            this.segmenter = segmenter
            this.fitter = fitter
        }
        val key = Key(req, cssFont(req.font, req.spec.maxSize, req.weight, req.italic))
        entries.remove(key)?.let { entries[key] = it; return it }
        val result = fitter.fit(req, measurer, segmenter)
        entries[key] = result
        if (entries.size > capacity) entries.remove(entries.keys.first())
        return result
    }
}
